import React from 'react';
import Staking from './Components/Staking';
import Benefits from './Components/Benefits';
import FAQ from './Components/FAQ';
import CallToAction from './Components/CallToAction';
import UpcomingProject from './Components/UpcomingProject';
import StakeProvider from './StakeProvider';
import { useDispatch } from 'react-redux';
import { getStakingConfig } from 'src/redux/actions';
import withScrollToTop from 'src/utils/withScrollToTop';
import useIntersectionObserver from 'src/hooks/useIntersectionObserver';
import BreakpointContent from 'src/Components/BreakpointContent';
import ScrollMobile from 'src/Pages/Staking/Components/StakingDashboard/Components/ScrollToTop/Components/ScrollMobile';
import ScrollDesktop from 'src/Pages/Staking/Components/StakingDashboard/Components/ScrollToTop/Components/ScrollDesktop';
import UserWalletProvider from '@profile/src/Profile_V2/UserWalletProvider';

const StakingDashboard = () => {
  var _stakingRef$current;

  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getStakingConfig());
  }, []);
  const stakingRef = React.useRef(null);
  const callToActionBtnRef = React.useRef(null);
  const eleStaking = useIntersectionObserver(stakingRef, {});
  const eleCallToActionBtn = useIntersectionObserver(callToActionBtnRef, {});
  const isHidingScrollAtTop = eleStaking ? eleStaking.isIntersecting : true;
  const isHidingScrollAtBottom = eleCallToActionBtn ? eleCallToActionBtn.isIntersecting : true;
  const yOffset = -100;
  const y = stakingRef.current ? (stakingRef === null || stakingRef === void 0 ? void 0 : (_stakingRef$current = stakingRef.current) === null || _stakingRef$current === void 0 ? void 0 : _stakingRef$current.getBoundingClientRect().top) + window.pageYOffset + yOffset : 0;

  const scrollToStaking = () => {
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  };

  const renderScrollToTop = () => {
    return /*#__PURE__*/React.createElement(BreakpointContent, {
      renderPhone: () => /*#__PURE__*/React.createElement(ScrollMobile, {
        isHidden: isHidingScrollAtTop || isHidingScrollAtBottom,
        onClick: scrollToStaking
      }),
      renderTablet: () => /*#__PURE__*/React.createElement(ScrollMobile, {
        isHidden: isHidingScrollAtTop || isHidingScrollAtBottom,
        onClick: scrollToStaking
      }),
      renderDesktop: () => /*#__PURE__*/React.createElement(ScrollDesktop, {
        isHidden: isHidingScrollAtTop,
        onClick: scrollToStaking
      })
    });
  };

  return /*#__PURE__*/React.createElement(UserWalletProvider, null, /*#__PURE__*/React.createElement(StakeProvider, null, /*#__PURE__*/React.createElement(Staking, {
    ref: stakingRef
  }), /*#__PURE__*/React.createElement(Benefits, null), /*#__PURE__*/React.createElement(UpcomingProject, null), /*#__PURE__*/React.createElement(FAQ, null), /*#__PURE__*/React.createElement(CallToAction, {
    ref: callToActionBtnRef,
    onButtonClick: scrollToStaking
  }), renderScrollToTop()));
};

export default withScrollToTop(StakingDashboard);